/* eslint-disable no-unused-vars */
import React from "react";
import { useLocation } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import FaqBeta from './Faqbeta';

function Header() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleRedirect = async () => {
        navigate("/");
    };

    return (
        <div className={`header ${location.pathname === "/" && "header_transparent"}`}>
            <div className="header_options d-flex aligin-items-center justify-content-between">
                <div className="header_logo ">
                    { location.pathname !== "/" &&
                        <button
                            name="closeChatButton"
                            className="close-chat-btn"
                            onClick={() => { handleRedirect() }}
                        >
                            <span>Close Chat</span>
                        </button>
                    }
                </div>
            </div>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasLeft" aria-labelledby="offcanvasLeftLabel">
                <div className="offcanvas-header d-flex justify-content-end">
                    <button name="closeButton" type="button" className="menu-close-icon mt-2 px-0" data-bs-dismiss="offcanvas" ><img src="/static/assets/close.svg" alt="close" /></button>
                </div>
                <div className="sidebar-body offcanvas-body">
                    <FaqBeta />
                </div>
            </div>
        </div>
    );
}

export default Header;